import React, { useState } from 'react';
import { ActivityAssociation } from 'v2/models';
import ActivityTabList from './ActivityTabList';
import ActivityTabHeader from './ActivityTabHeader';
import NoAssociationsPlaceholder from '../NoAssociationsPlaceholder/NoAssociationsPlaceholder';
import { IUseGetActivityProps } from 'v2/hooks/useGetActivities';

export interface ActivityTabProps
  extends Required<
    Pick<IUseGetActivityProps, 'relatedTable' | 'relatedObjectId'>
  > {
  defaultAssociations: ActivityAssociation[];
}

const ActivityTab = ({
  relatedTable,
  relatedObjectId,
  defaultAssociations,
}: ActivityTabProps) => {
  const [filterSelectedOption, setFilterSelectedOption] = useState<
    string | boolean | undefined
  >();
  const [filterSearchText, setFilterSearchText] = useState('');
  const [showCreateActivityModal, setShowCreateActivityModal] = useState(false);

  const listDescriptor: IUseGetActivityProps = {
    relatedTable,
    relatedObjectId,
    filterSearchText,
    filterSelectedOption,
  };

  return (
    <>
      <ActivityTabHeader
        listDescriptor={listDescriptor}
        defaultAssociations={defaultAssociations}
        showCreateModal={showCreateActivityModal}
        onCreateModalClose={() => setShowCreateActivityModal(false)}
        filterOnChange={(selectedOption) =>
          setFilterSelectedOption(selectedOption?.value as string)
        }
        filterOnSearch={(searchText) => setFilterSearchText(searchText)}
      />
      <ActivityTabList
        listDescriptor={listDescriptor}
        defaultAssociations={defaultAssociations}
      >
        <NoAssociationsPlaceholder
          onButtonClick={() => {
            setShowCreateActivityModal(true);
          }}
          buttonLabel="Add Activity"
        />
      </ActivityTabList>
    </>
  );
};

export default ActivityTab;
